import { render, staticRenderFns } from "./add-pg-form-dialog.vue?vue&type=template&id=0c02502b&scoped=true"
import script from "./add-pg-form-dialog.vue?vue&type=script&lang=js"
export * from "./add-pg-form-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-pg-form-dialog.vue?vue&type=style&index=0&id=0c02502b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02502b",
  null
  
)

export default component.exports